import { IConsuptionOptions } from '@/app/core/interfaces/consumption.interface';

export class GetGiAction {
  static readonly type = '[gi] Get GI Data';
  constructor(public payload: IConsuptionOptions) {}
}

export class ClearFiltersGI {
  static readonly type = '[gi] Clear Filters';
}

export class ResetClearFiltersGI {
  static readonly type = '[gi] Reset Clear Filters';
}
